import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import {
   MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS,
   MatLegacyTooltipDefaultOptions as MatTooltipDefaultOptions,
} from "@angular/material/legacy-tooltip";
import { DefaultTo } from "../../../shared/defaultTo.decorator";

export type ViewerTopBarConfig = {
   viewMode?: "default" | "share";
   fileName?: string;
   lastModifiedTime?: string;
   showBackButton?: boolean;
   showLogo?: boolean;
   /** Path of logo image to be shown between the 'back' button and filename. Default is zDox logo ('assets/images/zDox.png'). */
   logoPath?: string;
   showShareButton?: boolean;
   showStartFlowButton?: boolean;
   showOpenWithButton?: boolean;
   openWithMicrosoft?: { iconPath: string; name: string };
   openWithGoogle?: { iconPath: string; name: string };
   showDownloadButton?: boolean;
   showToggleInfoPanelButton?: boolean;
};

@Component({
   selector: "app-viewer-top-bar",
   templateUrl: "./viewer-top-bar.component.html",
   styleUrls: ["./viewer-top-bar.component.css"],
})
export class ViewerTopBarComponent {
   @Input() @DefaultTo("default") viewMode: "default" | "share";
   @Input() @DefaultTo(false) showLogo?: boolean;
   @Input() logoPath?: string;
   @Input() @DefaultTo("") fileName?: string;
   @Input() lastModifiedTime?: string;
   @Input() @DefaultTo(true) showBackButton?: boolean;
   @Input() showShareButton?: boolean;
   @Input() showStartFlowButton?: boolean;
   @Input() showOpenWithButton?: boolean;
   @Input() openWithMicrosoft?: { iconPath: string; name: string };
   @Input() openWithGoogle?: { iconPath: string; name: string };
   @Input() showDownloadButton?: boolean;
   @Input() @DefaultTo(true) showToggleInfoPanelButton?: boolean;

   @Output() clickBack = new EventEmitter();
   @Output() clickShare = new EventEmitter();
   @Output() clickStartFlow = new EventEmitter();
   @Output() clickOpenWithMicrosoft = new EventEmitter();
   @Output() clickOpenWithGoogle = new EventEmitter();
   @Output() clickDownload = new EventEmitter();
   @Output() toggleInfoPanel = new EventEmitter();

   dataShare: any;

   constructor(
      @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
      private tooltip: MatTooltipDefaultOptions
   ) {
      // FYI, after Angular 13, tooltip interactivity is enabled by default, but we don't want it.
      tooltip.disableTooltipInteractivity = true;
   }

   onClickBack() {
      this.clickBack.emit();
   }

   onClickStartFlow() {
      this.clickStartFlow.emit();
   }

   onClickShare() {
      this.clickShare.emit();
   }

   onClickOpenWithMicrosoft() {
      this.clickOpenWithMicrosoft.emit();
   }

   onClickOpenWithGoogle() {
      this.clickOpenWithGoogle.emit();
   }

   onClickDownload() {
      this.clickDownload.emit();
   }

   onClickToggleInfoPanel() {
      this.toggleInfoPanel.emit();
   }

   isPptFile(): boolean {
      return this.fileName.endsWith('.pptx') ||
             this.fileName.endsWith('.pptm') ||
             this.fileName.endsWith('.ppsx') ||
             this.fileName.endsWith('.ppsm') ||
             this.fileName.endsWith('.ppt') ||
             this.fileName.endsWith('.pot') ||
            this.fileName.endsWith('.pps');

    }
}
